<template>
  <path
    d="M.848 9h15.304M8.5 1.348v15.304"
    stroke="currentColor"
    fill="none"
    fill-rule="evenodd"
    stroke-linecap="square"
  />
</template>
